"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _core = require("@material-ui/core");
var _reactColor = require("react-color");
var _ContentCopy = _interopRequireDefault(require("mdi-material-ui/ContentCopy"));
var _Close = _interopRequireDefault(require("mdi-material-ui/Close"));
var _Alert = _interopRequireDefault(require("mdi-material-ui/Alert"));
var _Eye = _interopRequireDefault(require("mdi-material-ui/Eye"));
var _EyeOff = _interopRequireDefault(require("mdi-material-ui/EyeOff"));
var _reactNumberFormat = _interopRequireDefault(require("react-number-format"));
var _CharCount = _interopRequireDefault(require("../CharCount/CharCount"));
var _utils = require("../../utils");
var _TextField = require("./TextField.styles");
var _excluded = ["error", "hasError", "helperText", "type", "label", "secondaryLabel", "labelHidden", "id", "disabled", "readOnly", "name", "iconLeft", "iconRight", "append", "maxLength", "onFocus", "onBlur", "onChange", "placeholder", "withCopyToClipboard", "inputProps", "mode", "decimalScale", "numberPrefix", "size", "colorPicker", "colorPickerOnChange", "valueAccessor", "disableClearAll"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var TextField = function TextField(_ref) {
  var _classNames, _classNames2;
  var _ref$error = _ref.error,
    error = _ref$error === void 0 ? undefined : _ref$error,
    _ref$hasError = _ref.hasError,
    hasError = _ref$hasError === void 0 ? false : _ref$hasError,
    _ref$helperText = _ref.helperText,
    helperText = _ref$helperText === void 0 ? undefined : _ref$helperText,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? undefined : _ref$type,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? undefined : _ref$label,
    _ref$secondaryLabel = _ref.secondaryLabel,
    secondaryLabel = _ref$secondaryLabel === void 0 ? undefined : _ref$secondaryLabel,
    _ref$labelHidden = _ref.labelHidden,
    labelHidden = _ref$labelHidden === void 0 ? undefined : _ref$labelHidden,
    _ref$id = _ref.id,
    idProp = _ref$id === void 0 ? undefined : _ref$id,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$readOnly = _ref.readOnly,
    readOnly = _ref$readOnly === void 0 ? false : _ref$readOnly,
    name = _ref.name,
    _ref$iconLeft = _ref.iconLeft,
    iconLeft = _ref$iconLeft === void 0 ? undefined : _ref$iconLeft,
    _ref$iconRight = _ref.iconRight,
    iconRight = _ref$iconRight === void 0 ? undefined : _ref$iconRight,
    _ref$append = _ref.append,
    append = _ref$append === void 0 ? undefined : _ref$append,
    _ref$maxLength = _ref.maxLength,
    maxLength = _ref$maxLength === void 0 ? undefined : _ref$maxLength,
    _ref$onFocus = _ref.onFocus,
    onFocus = _ref$onFocus === void 0 ? function () {
      var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    } : _ref$onFocus,
    _ref$onBlur = _ref.onBlur,
    onBlur = _ref$onBlur === void 0 ? function () {
      var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    } : _ref$onBlur,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? undefined : _ref$onChange,
    _ref$placeholder = _ref.placeholder,
    placeholder = _ref$placeholder === void 0 ? undefined : _ref$placeholder,
    _ref$withCopyToClipbo = _ref.withCopyToClipboard,
    withCopyToClipboard = _ref$withCopyToClipbo === void 0 ? false : _ref$withCopyToClipbo,
    _ref$inputProps = _ref.inputProps,
    inputProps = _ref$inputProps === void 0 ? undefined : _ref$inputProps,
    _ref$mode = _ref.mode,
    mode = _ref$mode === void 0 ? '' : _ref$mode,
    _ref$decimalScale = _ref.decimalScale,
    decimalScale = _ref$decimalScale === void 0 ? 2 : _ref$decimalScale,
    _ref$numberPrefix = _ref.numberPrefix,
    numberPrefix = _ref$numberPrefix === void 0 ? '$ ' : _ref$numberPrefix,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'medium' : _ref$size,
    _ref$colorPicker = _ref.colorPicker,
    colorPicker = _ref$colorPicker === void 0 ? false : _ref$colorPicker,
    _ref$colorPickerOnCha = _ref.colorPickerOnChange,
    colorPickerOnChange = _ref$colorPickerOnCha === void 0 ? function (e) {} : _ref$colorPickerOnCha,
    _ref$valueAccessor = _ref.valueAccessor,
    valueAccessor = _ref$valueAccessor === void 0 ? function () {} : _ref$valueAccessor,
    _ref$disableClearAll = _ref.disableClearAll,
    disableClearAll = _ref$disableClearAll === void 0 ? false : _ref$disableClearAll,
    props = _objectWithoutProperties(_ref, _excluded);
  var id = idProp || name;
  var value = props.value;
  var _useState = (0, _react.useState)(),
    _useState2 = _slicedToArray(_useState, 2),
    color = _useState2[0],
    setColor = _useState2[1];
  var _useState3 = (0, _react.useState)(),
    _useState4 = _slicedToArray(_useState3, 2),
    inputRef = _useState4[0],
    setInputRef = _useState4[1];
  var _React$useState = _react.default.useState(null),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    anchorEl = _React$useState2[0],
    setAnchorEl = _React$useState2[1];
  var _useState5 = (0, _react.useState)(value === null || value === void 0 ? void 0 : value.length),
    _useState6 = _slicedToArray(_useState5, 2),
    valueLength = _useState6[0],
    setValueLength = _useState6[1];
  var _useState7 = (0, _react.useState)(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isFocused = _useState8[0],
    setIsFocused = _useState8[1];
  var _useState9 = (0, _react.useState)(type === 'password'),
    _useState10 = _slicedToArray(_useState9, 2),
    hidePassword = _useState10[0],
    setHidePassword = _useState10[1];
  var _useState11 = (0, _react.useState)({
      value: value,
      focused: false
    }),
    _useState12 = _slicedToArray(_useState11, 2),
    numberFormat = _useState12[0],
    setNumberFormat = _useState12[1];
  var handleRef = function handleRef(el) {
    setInputRef(el);
    if (props.inputRef) {
      if (typeof props.inputRef === 'function') {
        props.inputRef(el);
      } else {
        // eslint-disable-next-line no-param-reassign
        props.inputRef.current = el;
      }
    }
  };
  var showErrorState = Boolean(error) || hasError;
  var showErrorMessage = !!error;
  (0, _react.useEffect)(function () {
    if (inputRef !== null && inputRef !== void 0 && inputRef.value.length) {
      var inputRefValue = inputRef === null || inputRef === void 0 ? void 0 : inputRef.value;
      setValueLength(inputRefValue.length);
      if (colorPicker) {
        setColor("#".concat(inputRefValue));
      }
    }
  }, [inputRef, setValueLength, colorPicker]);

  // EVENTS
  var handleChange = function handleChange(event) {
    if (event.nativeEvent) {
      event.persist();
      setValueLength(event.target.value.length);
    }
    if (onChange) {
      onChange(event);
    }
    if (colorPicker) {
      var colorValue = event.target.value.replace('#', '').toUpperCase();
      colorValue = colorValue.replace(/[^0-9A-Fa-f]/g, '');
      colorValue = colorValue.substring(0, 6);
      var eventFinal = (0, _utils.buildEventTarget)(name, colorValue, [{
        name: 'hexValue',
        value: "#".concat(colorValue)
      }]);
      colorPickerOnChange(eventFinal);
      setColor("#".concat(colorValue));
    }
  };
  var handleClearAll = function handleClearAll() {
    inputRef.value = '';
    setValueLength(0);
    var event = (0, _utils.buildEventTarget)(name, '');
    if (onChange) {
      onChange(event);
    }
    if (colorPicker) {
      setColor('');
      if (colorPickerOnChange) {
        colorPickerOnChange(event);
      }
    }
  };
  var handlePopoverClick = function handlePopoverClick(event) {
    setAnchorEl(event.currentTarget);
  };
  var handlePopoverClose = function handlePopoverClose() {
    setAnchorEl(null);
  };
  var handleColorPicker = function handleColorPicker(colorValue) {
    var event = (0, _utils.buildEventTarget)(name, colorValue.hex.replace('#', '').toUpperCase());
    setColor(colorValue.hex);
    inputRef.value = event.target.value;
    setValueLength(colorValue.hex.length);
    if (colorPickerOnChange) {
      colorPickerOnChange(event);
    }
  };
  var handleFocus = function handleFocus(e) {
    setIsFocused(true);
    if (onFocus) {
      onFocus(e);
    }
  };
  var handleBlur = function handleBlur(e) {
    setIsFocused(false);
    if (onBlur) {
      onBlur(e);
    }
  };
  var handleHidePassword = function handleHidePassword(e) {
    setHidePassword(!hidePassword);
  };

  // STYLES
  var classes = (0, _TextField.useTextFieldStyles)();
  var cssInputBase = (0, _classnames.default)(classes.inputBase, (_classNames = {}, _defineProperty(_classNames, classes.inputDisabled, disabled || readOnly), _defineProperty(_classNames, classes.withAppend, append), _defineProperty(_classNames, classes.withColorPicker, colorPicker), _defineProperty(_classNames, classes.withIconLeft, iconLeft), _defineProperty(_classNames, classes.withIconRight, iconRight || type === 'password'), _defineProperty(_classNames, classes.inputError, showErrorState), _defineProperty(_classNames, classes.smallSize, size === 'small'), _defineProperty(_classNames, classes.checkbox, type === 'checkbox'), _classNames));
  var cssInputContainer = (0, _classnames.default)(classes.inputContainer, (_classNames2 = {}, _defineProperty(_classNames2, classes.inputContainerError, showErrorState), _defineProperty(_classNames2, 'with-color-picker', colorPicker), _defineProperty(_classNames2, 'input-type-number', type === 'number'), _classNames2));
  var cssInputLabel = (0, _classnames.default)(classes.inputLabel, _defineProperty({}, classes.inputLabelFocused, numberFormat.focused));
  var cssColorPickerButton = (0, _classnames.default)(classes.colorPickerButton, _defineProperty({}, classes.colorPickerFocused, isFocused));
  var cssHelperTextContainer = (0, _classnames.default)(classes.helperTextContainer, _defineProperty({}, classes.helperTextDisabled, disabled));

  // RENDERS
  var open = Boolean(anchorEl);
  var computedType = function computedType() {
    if (type === 'password') {
      if (hidePassword) {
        return 'password';
      }
      return 'text';
    }
    return type;
  };
  var formatValue = function formatValue(valueParam) {
    if (colorPicker && valueParam) {
      return valueParam.replace(/[^0-9A-Fa-f]/g, '');
    }
    return valueParam;
  };
  var renderColorPickerButton = /*#__PURE__*/_react.default.createElement("button", {
    className: cssColorPickerButton,
    "aria-label": "color picker",
    style: {
      backgroundColor: color
    },
    type: "button",
    onClick: handlePopoverClick,
    disabled: disabled
  });
  var colorPickerInput = /*#__PURE__*/_react.default.createElement(_core.Popover, {
    open: open,
    anchorEl: anchorEl,
    onClose: handlePopoverClose,
    classes: {
      root: classes.colorPopover
    },
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'center'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'center'
    }
  }, /*#__PURE__*/_react.default.createElement(_reactColor.ChromePicker, {
    color: color,
    onChange: handleColorPicker,
    disableAlpha: true
  }));
  return /*#__PURE__*/_react.default.createElement(_core.FormControl, {
    fullWidth: true,
    disabled: disabled,
    error: showErrorState
  }, !labelHidden && /*#__PURE__*/_react.default.createElement(_core.InputLabel, {
    classes: {
      root: cssInputLabel
    },
    shrink: true,
    htmlFor: id
  }, label, ' ', /*#__PURE__*/_react.default.createElement("span", {
    className: classes.secondaryLabel
  }, secondaryLabel)), /*#__PURE__*/_react.default.createElement("div", {
    className: cssInputContainer
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.iconLeft
  }, iconLeft), colorPicker && /*#__PURE__*/_react.default.createElement("span", {
    className: classes.hexIcon
  }, "#"), !mode && /*#__PURE__*/_react.default.createElement(_TextField.TextInputBase, _extends({
    id: id,
    type: computedType(),
    className: cssInputBase,
    disabled: disabled,
    readOnly: readOnly,
    placeholder: placeholder,
    onBlur: handleBlur,
    onFocus: handleFocus,
    onChange: handleChange,
    name: name,
    inputProps: inputProps
  }, props, {
    value: formatValue(value),
    inputRef: handleRef
  })), mode === 'numberformat' && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, _extends({}, props, {
    name: name,
    id: id,
    readOnly: readOnly,
    disabled: disabled,
    value: numberFormat.value,
    decimalScale: decimalScale,
    thousandSeparator: true,
    isNumericString: true,
    prefix: numberPrefix,
    onFocus: function onFocus() {
      setNumberFormat(function (state) {
        return _objectSpread(_objectSpread({}, state), {}, {
          focused: true
        });
      });
    },
    onBlur: function onBlur() {
      setNumberFormat(function (state) {
        return _objectSpread(_objectSpread({}, state), {}, {
          focused: false
        });
      });
    },
    onValueChange: function onValueChange(values) {
      setNumberFormat(function (state) {
        return _objectSpread(_objectSpread({}, state), {}, {
          value: values.floatValue
        });
      });
      if (onChange) {
        onChange({
          target: {
            value: values.floatValue
          }
        });
      }
    }
  }))), !disableClearAll && valueLength > 0 && !disabled && /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    className: classes.clearAll,
    onClick: handleClearAll
  }, /*#__PURE__*/_react.default.createElement(_Close.default, {
    fontSize: "inherit"
  })), withCopyToClipboard && /*#__PURE__*/_react.default.createElement(_core.Box, {
    className: classes.inputAction,
    ml: -4
  }, /*#__PURE__*/_react.default.createElement(_core.IconButton, {
    classes: {
      root: classes.inputActionButton
    },
    "aria-label": "Copy ".concat(label, " to Clipboard"),
    onClick: function onClick() {
      return (0, _utils.copyToClipboard)(valueAccessor());
    },
    size: "small",
    edge: "start"
  }, /*#__PURE__*/_react.default.createElement(_ContentCopy.default, null))), append, colorPicker && renderColorPickerButton, type === 'password' && /*#__PURE__*/_react.default.createElement("div", {
    className: classes.iconRight
  }, hidePassword ? /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    onClick: handleHidePassword
  }, /*#__PURE__*/_react.default.createElement(_Eye.default, {
    fontSize: "inherit"
  })) : /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    onClick: handleHidePassword
  }, /*#__PURE__*/_react.default.createElement(_EyeOff.default, {
    fontSize: "inherit"
  })))), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.footerContainer
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: cssHelperTextContainer
  }, !showErrorMessage && helperText && /*#__PURE__*/_react.default.createElement(_core.FormHelperText, null, helperText), showErrorMessage && /*#__PURE__*/_react.default.createElement("div", {
    className: classes.errorContainer
  }, /*#__PURE__*/_react.default.createElement(_Alert.default, {
    fontSize: "inherit"
  }), /*#__PURE__*/_react.default.createElement(_core.FormHelperText, null, error))), maxLength && /*#__PURE__*/_react.default.createElement(_CharCount.default, {
    className: classes.charCount,
    length: valueLength,
    maxLength: maxLength
  })), colorPicker && colorPickerInput);
};
var _default = TextField;
exports.default = _default;